import { HistoryToggleOff } from '@mui/icons-material';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { getLanguageTexts } from '@sharedInterfaces/Language/languageHelper';
import { useDialog } from '@src/App/Components/Dialogs/DialogManager';
import type { Entity } from '@src/Objects/Entity';
import type { AppState } from '@store/store';
import React from 'react';

import { useSelector } from 'react-redux';

import { VersionInfoDialog } from './VersionInfoDialog';

export default function VersionInfoButton({ entity, close }: { entity: Entity | undefined; close?: () => void }) {
    const { openDialog } = useDialog();
    const lang = useSelector((state: AppState) => state.employee.language);
    const langStrings = getLanguageTexts(lang).entityPage;

    if (!entity) return <></>;
    return (
        <MenuItem
            key="version-button"
            onClick={async () => {
                close?.();
                return openDialog(<VersionInfoDialog id="VersionInfoDialog" entity={entity} resolve={() => {}} />);
            }}
        >
            <ListItemIcon>
                <HistoryToggleOff />
            </ListItemIcon>
            <ListItemText>{langStrings.versionInfo}</ListItemText>
        </MenuItem>
    );
}
